import React from 'react';
import { Typography, Box, Paper, Stack } from '@mui/material';
import { QUESTION_TIPS } from './constants';

/**
 * Renders a tips card for questions editor.
 *
 * @param {QuestionTipsCardProps} props
 * @returns {JSX.Element}
 */
const QuestionTipsCard: React.FC<{ viewMode: boolean }> = ({ viewMode }) => {
    return (
        <Paper
            elevation={0}
            variant="outlined"
            sx={{ p: 2, alignSelf: 'flex-start', backgroundColor: 'gray.10' }}
            data-testid="question-tips-card"
        >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75 }}>
                {viewMode && (
                    <>
                        <Typography variant="body2" color="text.secondary" mb={0}>
                            Add questions for AI Insights to automatically analyze your project call transcripts and collect the insights
                            about your calls. The results will be displayed for each call in the Calls list.
                        </Typography>
                    </>
                )}
                {!viewMode && (
                    <>
                        <Box>
                            <Typography variant="h6" mb={0.5} color="text.secondary">
                                Tips for better questions
                            </Typography>
                            <Stack gap={0.5}>
                                {QUESTION_TIPS.map((tip, index) => (
                                    <Typography key={index} variant="body2" color="text.secondary" mb={0}>
                                        {tip}
                                    </Typography>
                                ))}
                            </Stack>
                        </Box>
                    </>
                )}
            </Box>
        </Paper>
    );
};

export default QuestionTipsCard;
